// @flow

export { default as Folder } from './Folder'
export { default as Text } from './Text'
export { default as CopyText } from './CopyText'
export { default as Image } from './Image'
export { default as Float } from './Float'
export { default as Fixed } from './Fixed'
export { default as Video } from './Video'
export { default as Popup } from './Popup'
export { default as RootMobile } from './RootMobile'
export { default as RootPc } from './RootPc'
export { default as Html } from './Html'
export { default as Swiper } from './Swiper'
export { default as Highcharts } from './Highcharts'
export { default as Highstock } from './Highstock'
export { default as IScroll } from './IScroll'
export { default as MarqueeLabel } from './MarqueeLabel'
export { default as Cropper } from './Cropper'
export { default as CountUp } from './CountUp'
export { default as QrCode } from './QrCode'
export { default as WeixinAppButton } from './Button'
export { default as Iframe } from './Iframe'
export { default as Lottie } from './Lottie'

export const ROOT_ID = 'rootEasyComp'



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/index.js